import {
  getCloseContractAnaliticData,
  getContractById,
} from '@/common/lib/contract';
import { SendAnalitics } from '@/common/lib/playdeck';
import { type OnQueryStartedHandler } from '@/common/types/query/common';
import { type RootState as RootStoreState } from '@/redux/store';

const completeOrRejectContractHandler = (
  reason: 'done' | 'reject',
): OnQueryStartedHandler<{ contractId: string }, unknown> => {
  return async function ({ contractId }, { queryFulfilled, getState }) {
    const { list: commonContracts, productOfDay: productContracts } = (
      getState() as RootStoreState
    ).contract;
    const contract = getContractById({
      commonContracts,
      productContracts,
      contractId,
    });

    try {
      await queryFulfilled;
      const analiticData = getCloseContractAnaliticData(contract);

      if (analiticData) {
        SendAnalitics.contractClose({ reason, ...analiticData });
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export { completeOrRejectContractHandler };
